export default __webpack_public_path__ + "static/media/294.2cf01699.png";